<template>
  <div class="flex items-center justify-center  mt-[-50px] max-w-[calc(100%-1rem)]">
    <div class="flex flex-col min-w-[calc(50%-5rem)] items-center justify-center w-1/2 p-20 min-h-90">
        <h1 class="!text-2xl !font-bold">Welcome to SmartPress</h1>
        <p>Your Wordpress Just got Smarter!</p>

        <ul class="steps steps-horizontal my-10">
        <li class="step step-primary" ref="step1">Verify Details</li>
        <li class="step" ref="step2">Creating Account</li>
        <li class="step" ref="step3">Training AI</li>
        <li class="step" ref="step4">Verify Email</li>
        </ul>

        <div class="text-lg" v-if="!isCreatingAccount">It takes only <b>One Click</b> to get started</div>
        <!-- Account Details gray simple div -->
        <div class="flex flex-col mt-4 bg-gray-200 p-4 rounded-lg" v-if="!isCreatingAccount">
            <div class="flex flex-row items-center justify-center">
                <label for="name">Name: </label>
                <input type="text" id="name" ref="nameInput" class="input input-bordered w-90 !ml-2" placeholder="Enter your name" v-model="name" disabled>
            </div>
            <div class="flex flex-row items-center justify-center mt-2">
                <label for="email">Email: </label>
                <input type="email" id="email" ref="emailInput" class="input input-bordered w-90 !ml-2" placeholder="Enter your email" v-model="email" disabled>
            </div>
            <div class="flex flex-row items-center justify-center mt-2" v-if="accessCode">
                <label for="code">Code: </label>
                <input type="text" id="code" ref="codeInput" class="input input-bordered w-90 !ml-2" placeholder="Enter your Code" v-model="code">
            </div>
            
           
        </div>
        <div class="flex mt-2 w-110" v-if="!isCreatingAccount" :class="accessCode ? 'justify-end' : 'justify-between'">
            <div class="badge badge-xs hover:scale-105 cursor-pointer transition-all duration-300 tooltip tooltip-right" data-tip="Use your purchased access code." @click="accessCode=true" v-if="!accessCode" ref="accessCodeButton">Access Code</div>
            <div class="badge badge-xs badge-secondary hover:scale-105 cursor-pointer transition-all duration-300" data-tip="Edit Information" @click="editInformation" ref="editInformationButton">Edit Information</div>
        </div>
        
        
        <!-- Confirm Details Button -->
        <badge @click="createAccount" ref="createAccountButton" v-if="!isCreatingAccount" class="font-light badge badge-primary badge-outline badge-lg my-4 hover:scale-105 hover:bg-primary hover:text-white cursor-pointer transition-all duration-300">
            Confirm Details & Get Started
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
            </svg>

        </badge>


        <!-- Creating a new Account Progress -->
        <div class="flex flex-col p-4 rounded-lg w-100 h-20 my-2 items-center justify-center text-center" v-if="isCreatingAccount">
          <div class="font-light" v-html="resultMessage"></div>
          <div ref="goToDashboardButton" class="font-light badge badge-primary badge-outline badge-lg hover:scale-105 hover:bg-primary hover:text-white cursor-pointer transition-all duration-300 my-4 hidden" @click="goToDashboard">Go to Dashboard</div>
        </div>

        <span class="text-sm font-light" v-if="!isCreatingAccount">Creating an account takes less than 1 minute</span>
    </div>

    <!-- Right hand side image -->
    <div class="flex flex-col min-w-[calc(50%-5.5rem)] items-center justify-center w-1/2 bg-primary rounded-lg text-secondary-content p-20 min-h-90">
        <img :src="`${pluginUrl}/assets/smart-press-logo.png`" alt="SmartPress Logo" class="w-10">
        <p>SmartPress allows you to use AI for content generation, You can even chat with it to moderate your website plugins, themes, content and more.</p>


        <!-- Image Carousel -->
        <div id="sample1">
            <div class="chat chat-end fade-up" style="animation-delay: 0s;">
                <div class="chat-bubble chat-bubble-secondary">Do I have any Draft posts?</div>
            </div>
            <div class="chat chat-start fade-up" style="animation-delay: 1s;">
                <div class="chat-bubble chat-bubble-white">Yes, you have <b>1 draft post</b>. Created on 2025-03-28, Want help publishing it?</div>
            </div>
            <div class="chat chat-end fade-up" style="animation-delay: 2s;">
                <div class="chat-bubble chat-bubble-secondary">Optimize the content for SEO and publish it</div>
            </div>
            <div class="chat chat-start fade-up" style="animation-delay: 5s;">
                <div class="chat-bubble chat-bubble-white">
                    I've <b>Optimized the content and published it</b>.<br/>
                    You can check it at <a href="#" target="_blank">https://yourwebsite.com/article-name</a>
                </div>
            </div>
            <div class="chat chat-end fade-up" style="animation-delay: 6s;">
                <div class="chat-bubble chat-bubble-secondary">Great, Can you create some tags for this article?</div>
            </div>
            <div class="chat chat-start fade-up" style="animation-delay: 9s;">
                <div class="chat-bubble chat-bubble-white">
                    Sure, I've created some tags for you that relate to the article content. <b>(SEO, Wordpress, AI, Content Creation)</b>
                    <br/>
                    And successfully added them to the article.
                </div>
            </div>
            <div class="chat chat-end fade-up" style="animation-delay: 10s;">
                <div class="chat-bubble chat-bubble-secondary">attach these tags to all relevant posts</div>
            </div>
            <div class="chat chat-start fade-up" style="animation-delay: 12s;">
                <div class="chat-bubble chat-bubble-white">
                    Done, <b>Attached these tags to relevant posts.</b>
                    <br/>
                    A total of <b>4 tags</b> attached to <b>12 posts</b>.
                    <br/>
                    SEO (<b>10</b>), Wordpress (<b>2</b>), AI (<b>12</b>), Content Creation (<b>2</b>).
                    
                </div>
            </div>
        </div>

    </div>
    
  </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'GetStarted',
    data() {
        return {
            pluginUrl: window.smartpress_vars.pluginUrl || '',
            name: window.smartpress_wpUserData.display_name || "",
            email: window.smartpress_wpUserData.user_email || "",
            isCreatingAccount: false,
            resultMessage: "",
            customFields: {},
            accessCode: false,
            code: ""
        }
    },
    methods: {
        createAccount() {
            // Disable the inputs
            this.$refs.nameInput.disabled = true;
            this.$refs.emailInput.disabled = true;
            // this.$refs.codeInput.disabled = true;
            this.$refs.editInformationButton.classList.add('hidden');
            this.resultMessage = `Creating an account <span class="loading loading-dots loading-sm"></span>`;

            // Add the step-primary class to the step2 element
            this.$refs.step2.classList.add('step-primary');
            this.$refs.createAccountButton.classList.add('hidden');
            this.authenticateUser();



            setTimeout(() => {
                // this.$refs.step4.classList.add('step-primary');
            }, 2000);
        },
        editInformation() {
           this.$refs.nameInput.disabled = false;
           this.$refs.emailInput.disabled = false;
           this.$refs.editInformationButton.classList.add('hidden');
        },
        async saveCustomFields() {
            console.log("Saving custom fields",this.customFields);
            this.saving = true;
            this.error = null;
            this.saveSuccess = false;
            
            let baseUrl = window.smartpress_wpUserData.site_url;
            try {
                const response = await fetch(`${baseUrl}/wp-json/smartpress/v1/custom-fields`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
                },
                body: JSON.stringify(this.customFields)
                });
                
                if (!response.ok) {
                throw new Error('Failed to save custom fields');
                }
                console.log(response);
                
                const data = await response.json();
                this.customFields = data;
                // Add to local storage
                localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
                this.saveSuccess = true;
                
                // Hide success message after 3 seconds
                setTimeout(() => {
                this.saveSuccess = false;
                }, 3000);
            } catch (error) {
                console.error('Error saving custom fields:', error);
                this.error = 'Failed to save custom fields. Please try again later.';
            } finally {
                this.saving = false;
            }
        },
        // Special Vesion of Authenticate User Function for Getting Started
        async authenticateUser(){
            this.isCreatingAccount = true;
            this.resultMessage = `Confirming Account Details <span class="loading loading-dots loading-sm"></span>`;
            try {
                const response = await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/auth', {
                name: this.name,
                email: this.email ,
                url:  window.smartpress_wpUserData.site_url,
                code: this.code
                });
                if(response.data.success){
                this.$refs.step3.classList.add('step-primary');

                    // request successful
                if(response.data.session){
                    // New Account / First Time Login
                    console.log("Authenticated user",response.data.session);
                    console.log("First Time User: ",this.email);
                    this.resultMessage = "Welcome <b>"+this.name+"</b>, your account has been created successfully. Please <b>Verify your email</b> to <i>Double your free monthly requests.</i>";
                    this.$refs.goToDashboardButton.classList.remove('hidden');
                    this.customFields.api_key = response.data.session;
                    this.customFields.email = this.email;
                    this.customFields.site_url = window.smartpress_wpUserData.site_url;
                    this.customFields.is_guest = true;
                    this.customFields.brand_data = this.trainAI();
                    this.saveCustomFields();
                }else{
                   if(response.data.exist == true){
                    // User already exists
                    console.log("User already exists",response.data.session);
                    this.resultMessage = "Account Already exists for <b>"+this.email+"</b>, Please check your email for a login link.";

                   }
                }

                }


            } catch (error) {
                console.error('Error authenticating user:', error);
            }
        },
        goToDashboard(){
            // redirect to /wp-admin/admin.php?page=smart-press
            window.location.href = window.smartpress_wpUserData.site_url + '/wp-admin/admin.php?page=smartpress';
        },
        async trainAI() {
            // get website url
            // const websiteUrl = window.location.origin;
            const websiteUrl = 'https://smartpress.10g8.com';
            // check if websiteUrl is localhost
            if (websiteUrl.includes('localhost')) {
                return;
            }
            try{
                // send websiteUrl to server
            const response = await axios.post('https://node.10g8.com/webhook/14a134f2-33f3-4c5c-be5b-58d0a4eb3f2f', { "website":websiteUrl });

                let brandData = response.data.output;
                return brandData;
            }catch(error){
                return false;
            }
            

        }
    }
}
</script>

<style scoped>
.fade-up {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeUp 0.5s forwards;
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

